import Component, { Topic } from 'component';

const ATTR_AUTOPLAY = 'autoplay';

customElements.define('x-carousel', class extends Component {
  constructor() {
    super();
    this.$element.navPrev = this.querySelector('[data-carousel-element="nav-prev"]');
    this.$element.navNext = this.querySelector('[data-carousel-element="nav-next"]');
    this.$element.items = this.querySelectorAll('.carousel__item');
  }

  currentItem = 0;
  itemsCount = 0;
  touching = false;
  delta = 0;
  autoplayInterval;
  autoplayTime = 0;
  pTouch = 0;
  transitioning = false;

  render() {
    this.autoplayTime = Number(this.getAttribute(ATTR_AUTOPLAY)) * 1000;
    this.itemsCount = Number(this.getAttribute('items-count'));

    this.setActiveItem();

    this.on(this.$element.navPrev, 'click', () => {
      this.updatePosition(-1);
    });

    this.on(this.$element.navNext, 'click', () => {
      this.updatePosition(1);
    });

    this.sub(Topic.CAROUSEL_PAGINATION_UPDATE, (index) => {
      this.setPosition(index);
    });

    this.on(this, 'animationend', (e) => {
      e.stopPropagation();
      this.classList.remove('carousel--animate');
      this.delta = 0;
      this.style.setProperty('--carousel-delta', this.delta.toString());
    });

    this.startAutoplay();
  }

  setActiveItem() {
    this.$element.items?.forEach((item, index) => {
      item.classList.toggle('is-active', index === this.currentItem);
      item.classList.remove('is-leaving');
    });
  }

  onMobile() {
    this.on(this, 'touchstart', () => {
      this.touching = true;
    });

    this.on(this, 'touchmove', (e) => {
      if (!this.touching) return;

      this.stopAutoplay();

      const [touch] = e.touches;

      if (this.pTouch) {
        this.delta += (touch.pageX - this.pTouch);
        this.style.setProperty('--carousel-delta', String(this.delta));
        this.style.setProperty('--carousel-direction', String(Math.sign(this.delta)));
      }

      this.pTouch = touch.pageX;
    });

    this.on(this, 'touchend', () => {
      this.touching = false;
      this.pTouch = 0;

      if (this.delta !== 0) {
        this.updatePosition(0 - Math.sign(this.delta));
      }

      this.delta = 0;
      this.style.setProperty('--carousel-delta', '0');
      this.style.setProperty('--carousel-shift', '0');
    });
  }

  updatePosition(direction, autoplay = false) {
  if (direction !== 0) {
    this.style.setProperty('--carousel-direction', String(direction));
  }

  this.setPosition(this.currentItem + direction, autoplay);
  this.pub(Topic.CAROUSEL_PAGINATION_SET, this.currentItem);
}

  setPosition(position, autoplay = false) {
    if (this.transitioning || position === this.currentItem) return;

    this.transitioning = true;

    const previousItem = this.currentItem;
    const previousSlide = this.$element.items?.item(previousItem);

    if (position >= this.itemsCount) {
      this.currentItem = 0;
    } else if (position < 0) {
      this.currentItem = this.itemsCount - 1;
    } else {
      this.currentItem = position;
    }

    const nextSlide = this.$element.items?.item(this.currentItem);

    previousSlide?.classList.add('is-leaving');
    previousSlide?.classList.remove('is-active');

    setTimeout(() => {
      previousSlide?.classList.remove('is-leaving');
      nextSlide?.classList.add('is-active');

      this.classList.add('carousel--animate');
      this.style.setProperty('--carousel-current-index', this.currentItem.toString());

      this.transitioning = false;
    }, 650);

    if (!autoplay && this.autoplayTime > 0) {
      this.resetAutoplay();
    }
  }

  startAutoplay() {
    if (this.autoplayTime > 0) {
      this.autoplayInterval = setInterval(() => {
        this.updatePosition(1, true);
      }, this.autoplayTime);
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  destroy() {
    this.stopAutoplay();
  }
});